module.exports = __webpack_public_path__ + "static/media/Jerusalem-revised.4b11ae40.png";